import { sound } from '@pixi/sound'
import bgMusicUrl from '../assets/sfx/bg.mp3?url'
import blastSfxUrl from '../assets/sfx/blast.mp3?url'
import takeoffSfxUrl from '../assets/sfx/takeoff.mp3?url'
import flyingSfxUrl from '../assets/sfx/flying.mp3?url'
import countSfxUrl from '../assets/sfx/count.mp3?url'

const SFX_DEFAULT_VOLUME = 0.5
const SFX_VOLUME_BG_MUSIC = 0.65

export class SoundManager {
	private static _instance: SoundManager | null = null
	private isMuted = false
	private loaded = false

	static get instance() {
		if (!this._instance) {
			this._instance = new SoundManager()
		}

		return this._instance
	}

	async load() {
		if (this.loaded) {
			return
		}

		const sounds = [
			{ alias: 'bgMusic', src: bgMusicUrl },
			{ alias: 'crash', src: blastSfxUrl },
			{ alias: 'takeOff', src: takeoffSfxUrl },
			{ alias: 'fly', src: flyingSfxUrl },
			{ alias: 'timer', src: countSfxUrl },
		]

		for (const item of sounds) {
			if (!sound.exists(item.alias)) {
				sound.add(item.alias, item.src)
			}
		}

		this.loaded = true
	}

	play(name: string, options: { loop?: boolean; volume?: number; speed?: number } = {}) {
		if (this.isMuted || !sound.exists(name)) {
			return
		}

		sound.play(name, {
			loop: options.loop ?? false,
			volume: options.volume ?? SFX_DEFAULT_VOLUME,
			speed: options.speed ?? 1,
		})
	}

	stop(name: string) {
		if (!sound.exists(name)) {
			return
		}

		sound.stop(name)
	}

	playMusic() {
		this.play('bgMusic', { loop: true, volume: SFX_VOLUME_BG_MUSIC })
	}

	stopMusic() {
		this.stop('bgMusic')
	}

	stopAllGameplay() {
		this.stopMusic()
		this.stop('fly')
		this.stop('takeOff')
		this.stop('crash')
		this.stop('timer')
	}

	mute() {
		this.isMuted = true
		sound.stopAll()
	}

	unmute() {
		this.isMuted = false
	}
}
